require('./bootstrap');

window.Vue = require('vue').default;

import eventBus from '@/event-bus';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
const files = require.context('./', true, /^((?![\\/]admin[\\/]).)*\.vue$/i);

files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Initialize Vue
const app = new Vue({
    el: '#app',
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', _.debounce(this.onResize, 150));
            window.addEventListener('scroll', _.debounce(this.onScroll, 150));
        })
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },

    methods: {
        onResize() {
            eventBus.$emit('windowResized', window.innerWidth);
        },
        onScroll() {
            eventBus.$emit('scrolled', window.window.scrollY);
        }
    }
});

